<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import OptionNote from './OptionNote/index.vue';
import confirmationOfInformation from './confirmationOfInformation/index.vue';
import submitSuccessfully from './submitSuccessfully/index.vue';
export default {
	components: {
		OptionNote,
		confirmationOfInformation,
		submitSuccessfully
	},
	props: {},
	watch: {},
	data() {
		return {
			//进度
			uptype: 1,
			headdata: getdata().headdata
		};
	},
	mounted() {},
	created() {},
	methods: {
		//返回
		switchInterfaceHuid() {
			this.$emit('switchInterfaceHuid', 0);
		},
		//接收返回
		OptionNoteclick(e) {
			this.uptype = e;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
